import React, { Component } from 'react';
// import { BrowserRouter as Router, Route, Switch, NavLink, Link } from "react-router-dom";//need to remove
import { NavLink, Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import secureStorage from './../../config/encrypt';
import MasterService from './../../service/MasterService';
import { REACT_APP_TENANT } from './../../config/constant';
import UploadCsvModal from '../dealer/component/UploadCsvModal';


class Navbar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            langOption : [],
            showUploadCsvModal: false,
        }
    }
    componentWillMount = ()=>{
        let self = this
        let localLangData = secureStorage.getItem('langOption');
        if(!localLangData) {
            MasterService.get('core/commonservice/master?master[]=lang').then((response)=>{
                if (response.status === 200 && response.data.status === 200 && response.data.data.lang != null) {
                    let langData = response.data.data.lang;
                    secureStorage.setItem('langOption', langData);
                    self.setState({langOption: langData});
                }
            });
        }else{
            self.setState({langOption: localLangData});
        }
    }

    handleLogout = () => {
        if (typeof this.props.logoutUser === 'function') {
            this.props.logoutUser();
        }
    }

    openUploadCsvModal = () => {
        this.setState({ showUploadCsvModal: true });
    };

    closeUploadCsvModal = () => {
        this.setState({ showUploadCsvModal: false });
    };

    render() {
        let name = "Admin";
        // let role, profileTitle, userType, dealerName,stock_category=[],is_bursa = 0;//need to remove
        let role, profileTitle, userType, dealerName,stock_category=[];
        let role_access = [], use;
        if (secureStorage.getItem('loginUserInfo')) {
            let loginResponse = secureStorage.getItem('loginUserInfo');
            role_access = loginResponse && loginResponse.data && loginResponse.data.user_data && loginResponse.data.user_data.role_data && loginResponse.data.user_data.role_data.length > 0 ? loginResponse.data.user_data.role_data : []
            // eslint-disable-next-line no-unused-vars
            use = loginResponse.data && loginResponse.data.user_data;
            if (loginResponse && loginResponse.data && loginResponse.data.user_data) {
                name = loginResponse.data.user_data.name;
                role = loginResponse.data.user_data.role;
                userType = loginResponse.data.user_data.role_type;
            }
            if (loginResponse && loginResponse.data && loginResponse.data.dealer_data && loginResponse.data.dealer_data[0]) {
                let dealer = loginResponse.data.dealer_data[0];
                if(Array.isArray(dealer.stock_category))
                    stock_category =  dealer.stock_category;
                dealerName = `${dealer.organization} (${dealer.gcd_code})`;
                secureStorage.setItem('IsBursa', dealer.is_bursa);
            }
            profileTitle = [dealerName, userType].filter(v => v).join(" | ")
        }

        const { i18n } = this.props;
        const selLang = secureStorage.getItem('lang') || 'en';
        const {langOption} = this.state;

        return (
            <nav className={this.props.navClass}>
                <ul className="navbar-nav">
                    {/* {role === 'admin' ? <li> <Link to="/admin/subscriptions">{this.props.t('menu.subscription')}</Link> </li> : ''} */}
                    <li><NavLink to="/" exact>{this.props.t('menu.home')}</NavLink></li>
                    {['dealercentral'].includes(role) ? <li> <Link to="/dealer-subscriptions">{this.props.t('menu.subscription')}</Link> </li> : ''}
                    {['dealercentral'].includes(role) ? <li> <Link to="/dealer-transactions">{'Transactions'}</Link> </li> : ''}
                    {role === 'admin' &&
                        <li className="dropdown"><NavLink to="/">{this.props.t('menu.dashboard')}<span className="caret"></span></NavLink>
                            <ul className="dropdown-menu">
                                {
                                  role_access.includes("menu_dealer_list") ?  <li> <Link to="/admin/dealer-list">{this.props.t('menu.dealer_manager')}</Link> </li> :''
                                }
                                {
                                  role_access.includes("menu_super_admin_report")?  <li> <Link to="/admin/super-admin-report">{this.props.t('menu.super_admin_report')}</Link> </li> :''
                                }
                                {
                                  role_access.includes("menu_reset_account_block")?  <li> <Link to="/admin/reset-account-block">{this.props.t('menu.reset_account_block')}</Link> </li> :''
                                }
                                {
                                  role_access.includes("menu_ac_manager") ?  <li> <Link to="/admin/ac-manager">{this.props.t('menu.account_manager')}</Link> </li> :''
                                }
                                {
                                  role_access.includes("menu_sales_support_users")  ?  <li> <Link to="/admin/sales-support-users">{this.props.t('menu.sales_support_user_dashboard')}</Link> </li> :''
                                }
                                 {!["tri-id","fav-id", "triv-id"].includes(REACT_APP_TENANT) ?
                                    role_access.includes("menu_dealer_list") ? <li> <Link to="/if-application/dashboard">{this.props.t('menu.if_dealer_dashboard')}</Link> </li> : ''
                                    : ""}
                                {!["tri-id","fav-id", "triv-id"].includes(REACT_APP_TENANT) ?
                                    role_access.includes("menu_inventory_funding") ? <li> <Link to="/admin/inventory-funding">{this.props.t('menu.inventory_funding')}</Link> </li> : ''
                                    : ""}
                                {!["tri-id","fav-id", "triv-id"].includes(REACT_APP_TENANT) ?
                                    role_access.includes("menu_dealer_sku") ? <li> <Link to="/admin/dealer_sku">{this.props.t('menu.dealer_sku')}</Link> </li> : ''
                                    : ""}
                                {!["tri-id","fav-id", "triv-id"].includes(REACT_APP_TENANT) ?
                                    role_access.includes("menu_dealer_sku") || true ? <li> <Link to="/admin/sku/transaction_list">{this.props.t('menu.sku_transaction')}</Link> </li> : ''
                                : ""}
                                {
                                    role_access.includes("menu_dealer_list") ?
                                        <li>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <a
                                                href="javascript:void(0)" // eslint-disable-line no-script-url, jsx-a11y/anchor-is-valid
                                                onClick={this.openUploadCsvModal}
                                            >
                                                {this.props.t('menu.uploda_fid_category')}
                                            </a>
                                        </li>
                                        : ''
                                }

                            </ul>
                        </li>}
                    {role === 'dealercentral' && <>
                        <li className="dropdown">
                            <NavLink to={{ pathname: '/manage-stock', state: 'freshLoadStock' }}
                                isActive={(match, location) => {
                                    if (location.pathname === '/add-stock' || location.pathname === '/manage-stock') { return true; }
                                }}>
                                {this.props.t('menu.stock_manager')}<span className="caret"></span></NavLink>
                            <ul className="dropdown-menu">
                                {(stock_category.includes(1)) ?
                                    <><li><NavLink to={{ pathname: '/manage-stock', state: 'freshLoadStock' }}>{this.props.t('menu.manage_stock')}</NavLink></li>
                                        <li><NavLink to="/add-stock">{this.props.t('menu.add_stock')}</NavLink></li></>
                                    : ""}
                                {(stock_category.includes(3)) ?
                                    <><li><NavLink to={{ pathname: '/manage-truck', state: 'freshLoadStock' }}>{this.props.t('menu.manage_truck')}</NavLink></li>
                                        <li><NavLink to="/add-truck">{this.props.t('menu.add_truck')}</NavLink></li></>
                                    : ""}
                            </ul>
                        </li>
                        <li className="dropdown">
                            <NavLink to="/lead"
                                isActive={(match, location) => {
                                    if (location.pathname === '/add-lead' || location.pathname === '/lead') { return true; }
                                }}>{this.props.t('menu.buyer_enquiry')}<span className="caret"></span></NavLink>
                                <ul className="dropdown-menu">
                                    <li><Link to={{ pathname: '/lead', state: 'loadAllLead' }}>{this.props.t('menu.manage_enquiry')}</Link></li>
                                    <li><Link to="/add-lead">{this.props.t('menu.add_enquiry')}</Link></li>
                                </ul>
                        </li>
                    </>}
                    <li className="dropdown myac" title={profileTitle || ''}><a href={() => false}>
                        <span className="userac"><i className="ic-person"></i></span>
                        {this.props.t('menu.hi')} {name}<span className="caret"></span></a>
                        <ul className="dropdown-menu">
                            {role === 'dealercentral' && <li><NavLink to="/my-account/basic-details">{this.props.t('menu.my_account')}</NavLink></li>}
                            <li onClick={this.handleLogout}><NavLink to="">{this.props.t('menu.logout')}</NavLink></li>
                        </ul>
                    </li>
                    {langOption && langOption.length > 1 ?
                        <li>
                            <div className="language-change">
                                {langOption.map((lang, index) =>
                                    <button key={index} type='button' className={selLang === lang.iso_code?'btn btn-primary':'btn btn-default'} onClick={() => {
                                        secureStorage.setItem('lang', lang.iso_code);
                                        i18n.changeLanguage(lang.iso_code)
                                    }}>{lang.iso_code}</button>
                                )}
                            </div>
                        </li>
                    : ''}
                </ul>
                <UploadCsvModal
                    show={this.state.showUploadCsvModal}
                    onClose={this.closeUploadCsvModal}
                />
            </nav>
        )
    }
}

export default withTranslation('common')(Navbar);